// Dummy Hindi news content for Denva Post demo
// All content is fictional placeholder for client presentation only.

export const IMG = {
  heroNarmada: "https://images.pexels.com/photos/34741303/pexels-photo-34741303.jpeg",
  mpPolitics: "https://images.pexels.com/photos/2245194/pexels-photo-2245194.jpeg",
  religion: "https://images.pexels.com/photos/34421611/pexels-photo-34421611.jpeg",
  cricket: "https://images.unsplash.com/photo-1643294358128-0d2da3b4ea7a",
  education: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg",
  market: "https://images.unsplash.com/photo-1769634306787-7f2fff1cca7d",
  nationalTech: "https://images.pexels.com/photos/31259265/pexels-photo-31259265.jpeg",
  agriculture: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449",
  infra: "https://images.pexels.com/photos/258510/pexels-photo-258510.jpeg",
  medical: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d",
  meeting: "https://images.unsplash.com/photo-1556761175-4b46a572b786",
  stock: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3",
};

export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_content-pipeline-62/artifacts/je9u0dms_News%20Logo.png";

export const BREAKING = [
  "नर्मदापुरम में तवा बांध के 9 गेट खुले, निचले इलाकों में अलर्ट जारी",
  "मुख्यमंत्री ने पचमढ़ी में समीक्षा बैठक की, पर्यटन विकास पर ज़ोर",
  "इटारसी जंक्शन पर नई वंदे भारत का ट्रायल रन सफल",
  "सोहागपुर में सहकारी समिति चुनाव को लेकर सरगर्मी",
  "सिवनी मालवा में किसान सम्मेलन आज, बीज वितरण होगा",
  "बाबई क्षेत्र के स्कूलों में स्मार्ट क्लासरूम की शुरुआत",
];

export const HERO = {
  eyebrow: "नर्मदापुरम संभाग · लीड स्टोरी",
  headline: "तवा के तटों पर उमड़ा जनसैलाब, नर्मदा जयंती पर लाखों दीयों से जगमगाया घाट",
  dek: "सेठानी घाट से लेकर विवेकानंद घाट तक—श्रद्धालुओं का सैलाब, प्रशासन ने तैनात किए 800 से अधिक जवान। रात्रि आरती में मुख्यमंत्री और केंद्रीय मंत्री की उपस्थिति ने आयोजन को ऐतिहासिक बना दिया।",
  meta: "नर्मदापुरम · 3 घंटे पहले · संपादकीय डेस्क",
};

export const NARMADAPURAM = [
  {
    id: "n1",
    kicker: "इटारसी",
    title: "इटारसी रेलवे यार्ड में लगी आग, माल गोदाम में करोड़ों का नुकसान",
    img: IMG.infra,
    time: "45 मिनट पहले",
  },
  {
    id: "n2",
    kicker: "पिपरिया",
    title: "पचमढ़ी घाट पर पर्यटन सीज़न शुरू, होटलों में 80% बुकिंग फुल",
    img: IMG.agriculture,
    time: "2 घंटे पहले",
  },
  {
    id: "n3",
    kicker: "सोहागपुर",
    title: "गन्ना किसानों ने की गोष्ठी—भाव नहीं मिलने पर आंदोलन की चेतावनी",
    img: IMG.market,
    time: "3 घंटे पहले",
  },
  {
    id: "n4",
    kicker: "बाबई",
    title: "नई सड़क परियोजना को केंद्र से मंज़ूरी, 78 करोड़ रुपये स्वीकृत",
    img: IMG.meeting,
    time: "आज सुबह",
  },
];

export const MP = [
  {
    id: "mp1",
    kicker: "भोपाल",
    title: "विधानसभा सत्र आज से, विपक्ष ने कानून-व्यवस्था पर लाया स्थगन प्रस्ताव",
    img: IMG.mpPolitics,
    time: "1 घंटा पहले",
    lead: true,
  },
  {
    id: "mp2",
    kicker: "इंदौर",
    title: "स्मार्ट सिटी रैंकिंग में इंदौर लगातार सातवीं बार शीर्ष पर",
    img: IMG.infra,
    time: "आज",
  },
  {
    id: "mp3",
    kicker: "जबलपुर",
    title: "हाईकोर्ट का बड़ा आदेश—अवैध खनन पर रोक, कलेक्टरों को नोटिस",
    img: IMG.meeting,
    time: "2 घंटे पहले",
  },
  {
    id: "mp4",
    kicker: "ग्वालियर",
    title: "तानसेन समारोह की भव्य तैयारी, देश-विदेश से पहुंचेंगे कलाकार",
    img: IMG.religion,
    time: "आज",
  },
  {
    id: "mp5",
    kicker: "उज्जैन",
    title: "महाकाल लोक के दूसरे चरण का लोकार्पण अगले माह",
    img: IMG.religion,
    time: "आज सुबह",
  },
];

export const NATIONAL = [
  {
    id: "na1",
    kicker: "नई दिल्ली",
    title: "संसद के शीतकालीन सत्र में पेश होंगे 15 विधेयक, वक्फ पर टकराव के आसार",
    img: IMG.meeting,
    time: "1 घंटा पहले",
    lead: true,
  },
  {
    id: "na2",
    kicker: "मुंबई",
    title: "सेंसेक्स ने लगाई 780 अंकों की छलांग, IT और बैंकिंग शेयर उछले",
    img: IMG.stock,
    time: "बाज़ार बंद होते ही",
  },
  {
    id: "na3",
    kicker: "बेंगलुरु",
    title: "इसरो का नया मिशन तय, फरवरी में लॉन्च होगा गगनयान परीक्षण मॉड्यूल",
    img: IMG.nationalTech,
    time: "आज",
  },
  {
    id: "na4",
    kicker: "चेन्नई",
    title: "पूर्वी तट पर चक्रवात का असर, तमिलनाडु और पुडुचेरी में हाई अलर्ट",
    img: IMG.infra,
    time: "अभी अभी",
  },
];

export const EXCLUSIVE = [
  {
    n: "01",
    kicker: "ग्राउंड रिपोर्ट",
    title: "तवा से बरगी तक—मध्यप्रदेश की जीवनरेखा नर्मदा के 12 घाटों की ज़मीनी हक़ीक़त",
    excerpt: "देनवा पोस्ट की एक विशेष पड़ताल—प्लास्टिक, अवैध रेत खनन और सूखते सहायक स्रोतों की कहानी, आँकड़ों और तस्वीरों के साथ।",
    author: "अंकित तिवारी",
  },
  {
    n: "02",
    kicker: "इन्वेस्टिगेशन",
    title: "फर्ज़ी दस्तावेज़ों का जाल—इटारसी में ज़मीन के सौदों की भीतरी परतें",
    excerpt: "छह महीनों की तहक़ीक़ात में सामने आए 40 से अधिक संदिग्ध लेन-देन। रजिस्ट्री, राजस्व रिकॉर्ड और स्थानीय पटवारियों तक फैली कड़ियाँ।",
    author: "प्रीति चौहान",
  },
  {
    n: "03",
    kicker: "इंटरव्यू",
    title: "‘सतपुड़ा की पहाड़ियाँ अभी बहुत कुछ कहती हैं’—प्रख्यात भूगर्भशास्त्री से बातचीत",
    excerpt: "पचमढ़ी की जैव-विविधता, बदलती जलवायु और उन आदिवासी समुदायों की बात, जिनकी आवाज़ें अक्सर हाशिये पर रह जाती हैं।",
    author: "देनवा संपादकीय",
  },
];

export const VIDEOS = [
  {
    id: "v1",
    title: "तवा बांध के गेट खुलते ही यूं फूट पड़ा नर्मदा का वेग—देखें ड्रोन फुटेज",
    dur: "3:24",
    thumb: IMG.heroNarmada,
    cat: "नर्मदापुरम",
  },
  {
    id: "v2",
    title: "पचमढ़ी की सर्द वादियों में सैलानियों का उमड़ा हुजूम",
    dur: "2:11",
    thumb: IMG.agriculture,
    cat: "पर्यटन",
  },
  {
    id: "v3",
    title: "मुख्यमंत्री का इटारसी दौरा—बड़ी घोषणाएँ, पूरा भाषण",
    dur: "12:48",
    thumb: IMG.mpPolitics,
    cat: "राजनीति",
  },
  {
    id: "v4",
    title: "किसान महापंचायत में क्या बोले किसान नेता—रिपोर्ट",
    dur: "5:36",
    thumb: IMG.market,
    cat: "किसान",
  },
  {
    id: "v5",
    title: "महाकाल मंदिर में भस्म आरती के भीतरी दृश्य",
    dur: "4:02",
    thumb: IMG.religion,
    cat: "धर्म",
  },
];

export const UTILITY = [
  { id: "u1", title: "आज बिजली कटौती: जानिए किन इलाकों में रहेगी सप्लाई बंद", img: IMG.medical, time: "आज" },
  { id: "u2", title: "पेट्रोल-डीज़ल के नए दाम, नर्मदापुरम में आज इतना महँगा", img: IMG.market, time: "आज" },
  { id: "u3", title: "स्थानीय ट्रेनों का बदला टाइम-टेबल, पूरी सूची यहाँ", img: IMG.infra, time: "आज" },
];

export const RELIGION = [
  { id: "r1", title: "आज का पंचांग: शुभ मुहूर्त, राहुकाल और चौघड़िया", img: IMG.religion, time: "प्रात:" },
  { id: "r2", title: "मार्गशीर्ष माह के आख़िरी सोमवार का महत्व—व्रत विधि", img: IMG.religion, time: "आज" },
  { id: "r3", title: "12 राशियों का दैनिक भविष्यफल—कैसा रहेगा आपका दिन", img: IMG.religion, time: "आज" },
];

export const CAREER = [
  { id: "c1", title: "MPPSC ने जारी की नई भर्ती अधिसूचना, 1,247 पद खाली", img: IMG.education, time: "आज" },
  { id: "c2", title: "रेलवे में 32 हज़ार पदों की भर्ती—आवेदन की तारीख़ें", img: IMG.education, time: "आज" },
  { id: "c3", title: "स्किल इंडिया कोर्सेज़ अब मुफ़्त—कैसे करें रजिस्टर", img: IMG.education, time: "आज" },
];

export const SPORTS = [
  { id: "s1", title: "टेस्ट सीरीज़ में भारत की धमाकेदार वापसी, बुमराह का पंजा", img: IMG.cricket, time: "1 घंटा पहले" },
  { id: "s2", title: "MP के युवा तेज़ गेंदबाज़ का IPL नीलामी में चौंकाने वाला दाम", img: IMG.cricket, time: "कल" },
  { id: "s3", title: "खेलो इंडिया में मध्यप्रदेश को दो और पदक", img: IMG.cricket, time: "आज" },
];

export const MOST_READ = [
  "तवा बांध से रेत निकासी पर एनजीटी की चेतावनी",
  "पचमढ़ी में आज से शुरू हुआ शीतकालीन उत्सव",
  "इटारसी बायपास पर हादसा—तीन घायल",
  "बाबई में नई कृषि मंडी का शिलान्यास",
  "सोहागपुर विधानसभा में युवा नेतृत्व की हलचल",
];

export const CATEGORIES = [
  { key: "home", label: "होम" },
  { key: "narmadapuram", label: "नर्मदापुरम" },
  { key: "mp", label: "मध्यप्रदेश" },
  { key: "national", label: "देश-दुनिया" },
  { key: "politics", label: "राजनीति" },
  { key: "rajkaj", label: "जनसंपर्क", dropdown: [
    { label: "मध्य प्रदेश", url: "https://www.mpinfo.org/" },
    { label: "छत्तीसगढ़", url: "https://dprcg.gov.in/" },
  ] },
  { key: "edujobs", label: "शिक्षा-रोजगार" },
  { key: "utility", label: "काम की बात" },
  { key: "sportsent", label: "खेल-मनोरंजन" },
  { key: "religion", label: "धर्म संस्कृति" },
  { key: "exclusive", label: "देनवा एक्सक्लूसिव" },
];

// Latest news ticker/slider items (Hero)
export const LATEST = [
  { id: "l1", kicker: "नर्मदापुरम", title: "तवा बांध से छोड़ा गया पानी, इटारसी के निचले घाट खाली कराए गए", img: IMG.infra, time: "10 मिनट पहले" },
  { id: "l2", kicker: "भोपाल", title: "मंत्रिमंडल की बैठक आज, कई अहम प्रस्तावों पर लगेगी मुहर", img: IMG.mpPolitics, time: "30 मिनट पहले" },
  { id: "l3", kicker: "देश", title: "संसद में आज पेश होगा नया विधेयक, विपक्ष का हंगामा तय", img: IMG.meeting, time: "1 घंटा पहले" },
  { id: "l4", kicker: "खेल", title: "टेस्ट सीरीज़ में भारत की पकड़ मज़बूत, तीसरे दिन बड़ी बढ़त", img: IMG.cricket, time: "1 घंटा पहले" },
  { id: "l5", kicker: "पचमढ़ी", title: "शीतकालीन पर्यटन उत्सव का रंगारंग आगाज़", img: IMG.agriculture, time: "2 घंटे पहले" },
];

// राजनीति
export const POLITICS = [
  { id: "p1", kicker: "भोपाल", title: "प्रदेश अध्यक्ष के दौरे से पहले संगठन में फेरबदल के संकेत", img: IMG.mpPolitics, time: "1 घंटा पहले", lead: true },
  { id: "p2", kicker: "नर्मदापुरम", title: "नगरीय निकाय चुनाव को लेकर दोनों दलों में बढ़ी सरगर्मी", img: IMG.meeting, time: "2 घंटे पहले" },
  { id: "p3", kicker: "दिल्ली", title: "गठबंधन की बैठक में सीट बंटवारे पर मंथन", img: IMG.meeting, time: "आज" },
  { id: "p4", kicker: "इटारसी", title: "युवा नेतृत्व को आगे लाने की तैयारी, नई टीम घोषित", img: IMG.mpPolitics, time: "आज सुबह" },
];

// राजकाज (governance / administration)
export const RAJKAJ = [
  { id: "rk1", kicker: "कलेक्ट्रेट", title: "कलेक्टर ने की समय-सीमा बैठक, लंबित शिकायतों पर सख़्ती", img: IMG.meeting, time: "1 घंटा पहले", lead: true },
  { id: "rk2", kicker: "सुशासन", title: "CM हेल्पलाइन में नर्मदापुरम की रैंकिंग सुधरी, तीसरे स्थान पर", img: IMG.infra, time: "आज" },
  { id: "rk3", kicker: "राजस्व", title: "सीमांकन के लंबित प्रकरण 30 दिन में निपटाने के निर्देश", img: IMG.market, time: "2 घंटे पहले" },
  { id: "rk4", kicker: "पंचायत", title: "ग्राम पंचायतों में विकास कार्यों का सोशल ऑडिट शुरू", img: IMG.agriculture, time: "आज सुबह" },
];

// खेल—मनोरंजन (entertainment items to pair with SPORTS)
export const ENTERTAINMENT = [
  { id: "e1", kicker: "सिनेमा", title: "इस हफ़्ते रिलीज़ हुई बड़ी फ़िल्म ने तोड़े ओपनिंग रिकॉर्ड", img: IMG.stock, time: "आज" },
  { id: "e2", kicker: "मनोरंजन", title: "भोपाल में सजी संगीत संध्या, दर्शकों का उमड़ा हुजूम", img: IMG.religion, time: "कल" },
  { id: "e3", kicker: "OTT", title: "मध्यप्रदेश की कहानी पर बनी वेब सीरीज़ की ख़ूब चर्चा", img: IMG.nationalTech, time: "आज" },
];
